import { REGION_DISPLAY_ORDER, type LoungeRegion } from '../loungePassesConstants'
import AIRPORT_LOUNGE_INDEX from './airportLoungeIndex'
import CONTINENT_AIRPORT_INDEX from './continentAirportIndex'

const FEATURED_COUNTRIES_PER_REGION = 2
const FEATURED_LOUNGES_PER_REGION = 4

/**
 * For each region, pick the top countries with the most airports,
 * then collect lounge IDs from those airports.
 *
 * This is a temporary solution — will be replaced when lounge data
 * includes region/country metadata from the experiences service.
 */
function getFeaturedLoungeIdsByRegion(): Record<LoungeRegion, Array<string>> {
  const result = {} as Record<LoungeRegion, Array<string>>
  for (const region of REGION_DISPLAY_ORDER) {
    const countries = [...CONTINENT_AIRPORT_INDEX[region]]
      .sort((a, b) => b.airports.length - a.airports.length)
      .slice(0, FEATURED_COUNTRIES_PER_REGION)

    const loungeIds: Array<string> = []
    for (const country of countries) {
      for (const airport of country.airports) {
        const ids = AIRPORT_LOUNGE_INDEX[airport.id] ?? []
        loungeIds.push(...ids)
        if (loungeIds.length >= FEATURED_LOUNGES_PER_REGION) break
      }
      if (loungeIds.length >= FEATURED_LOUNGES_PER_REGION) break
    }
    result[region] = loungeIds.slice(0, FEATURED_LOUNGES_PER_REGION)
  }
  return result
}

export default getFeaturedLoungeIdsByRegion
